import {ERegistrationType} from 'src/containers/LeadCompanyClients/definitions';

import {EBillingStatus} from './definitions';

export default {
  title: 'Клиенты компании',
  searchPlaceholder: 'Быстрый поиск по названию, ИНН и логину ',
  unknownCompanyName: 'Не заполнено имя компании',
  th: {
    createdAt: 'Дата создания',
    company: 'Компания',
    taxNumber: 'ИНН',
    login: 'Логин',
    status: 'Статус',
  },
  queryError: {
    title: 'Упс :(',
    subtitle: 'Из-за спецсимволов в поиске мы не смогли найти вашего клиента',
    hint: 'Попробуйте поискать без них',
  },
  filters: {
    title: 'Фильтры',
    createdAtLabel: 'Дата регистрации',
    managerLabel: 'Ответственный менеджер',
    managerPlaceholder: 'Выберите менеджера',
    resellerLabel: 'Юрисдикция',
    resellerPlaceholder: 'Выберите юрлицо',
    supportClients: 'Клиентов',
    tenantStatus: 'Статус тенанты',
    channels: 'Каналы в тенанте',
    licenseStatus: 'Статус лицензии',
    billing: 'Биллинг',
    registrationType: 'Тип регистрации',
    registrationTypes: {
      [ERegistrationType.SELF_SERVICE]: 'Саморегистрация',
      [ERegistrationType.ADMIN_CREATED]: 'Ручное создание',
    },
    billingStatus: {
      [EBillingStatus.ON]: 'Биллинг включен',
      [EBillingStatus.OFF]: 'Биллинг выключен',
    },
    documentType: 'Тип договора',
  },
};
